import { Injectable } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {
    ConfiguracionOpcionesModalInput,
    ModalDecisionComponent,
    ModalErrorComponent,
    ModalInfoComponent,
    ModalInputComponent,
    ModalSuccessComponent,
    ModalInfiniteSpinnerComponent
} from "@shared/components";
import { ModalDateComponent } from "@shared/components/modal-date/modal-date.component";
import { Nilable } from "@shared/utils";
import {
    CanjesModalErrorComponent
} from "../../layout/canjes/canjes-lista/canjes-modal/canjes-modal-error/canjes-modal-error.component";

@Injectable({
    providedIn: "root"
})
export class ModalService {
    constructor(private ngbModal: NgbModal) {}

    public open(component: any, opciones?: NgbModalOptions) {
        return this.ngbModal.open(component, opciones);
    }

    public async openModalInfo(mensaje: string, opciones?: NgbModalOptions): Promise<void> {
        const modalRef = this.ngbModal.open(ModalInfoComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;

        await modalRef.result.catch(() => {});
    }

    public async openModalDecision(mensaje: string, opciones?: NgbModalOptions): Promise<boolean> {
        const modalRef = this.ngbModal.open(ModalDecisionComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;

        const result = await modalRef.result.catch(() => {});

        return result === "aceptar";
    }

    public async openModalError(mensaje: string, opciones?: NgbModalOptions): Promise<void> {
        const modalRef = this.ngbModal.open(ModalErrorComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;

        await modalRef.result.catch(() => {});
    }

    public async openModalInput(
        mensaje: string, inputValor: string, opciones?: NgbModalOptions
    ): Promise<Nilable<string>> {
        const modalRef = this.ngbModal.open(ModalInputComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;
        modalRef.componentInstance.inputValor = inputValor;

        return await modalRef.result.catch(() => null);
    }

    public async openModalInputNumero(
        mensaje: string, inputValor: number, opciones?: NgbModalOptions
    ): Promise<number> {
        const modalRef = this.ngbModal.open(ModalInputComponent, opciones);

        modalRef.componentInstance.esNumero = true;
        modalRef.componentInstance.mensaje = mensaje;
        modalRef.componentInstance.inputValorNumero = inputValor;

        return await modalRef.result.catch(() => { });
    }

    public async openModalInputOpciones<T>(
        configuracion: ConfiguracionOpcionesModalInput<T>, opciones?: NgbModalOptions
    ): Promise<any> {
        const modalRef = this.ngbModal.open(ModalInputComponent, opciones);
        const instancia: ModalInputComponent<T> = modalRef.componentInstance;

        modalRef.componentInstance.mensaje = configuracion.multiple ? "Seleccione las opciones" : "Seleccione una opcion";
        instancia.esOpciones = true;
        instancia.configuracionOpciones = configuracion;
        instancia.item = configuracion.item;

        return await modalRef.result.catch(() => configuracion.multiple ? [] : null);
    }

    public async openCanjesModalError(mensaje: string, opciones?: NgbModalOptions): Promise<string> {
        const modalRef = this.ngbModal.open(CanjesModalErrorComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;

        return await modalRef.result.catch(() => { });
    }

    public async openModalSuccess(mensaje: string, opciones?: NgbModalOptions): Promise<void> {
        const modalRef = this.ngbModal.open(ModalSuccessComponent, opciones);

        modalRef.componentInstance.mensaje = mensaje;

        await modalRef.result.catch(() => {});
    }

    public async openModalInputDateTime(
        mensaje: string, fechaCargar: Nilable<Date> = null, autodisable: boolean, opciones?: NgbModalOptions
    ): Promise<[Nilable<Date>, boolean]> {
        const modalRef = this.ngbModal.open(ModalDateComponent, opciones);
        const instancia: ModalDateComponent = modalRef.componentInstance;
        instancia.mensaje = mensaje;
        instancia.cargarFecha(fechaCargar);
        instancia.cargarBoolean(autodisable);
        return await modalRef.result.catch(() => null);
    }

    public openModalInfiniteSpinner (
        spinnerMessage: string,
        opciones?: NgbModalOptions
      ): NgbModalRef {

        const spinnerModalRef = this.ngbModal.open(ModalInfiniteSpinnerComponent, {
          backdrop: "static", // Prevent closing by clicking outside
          keyboard: false, // Prevent closing with Esc key
          ...opciones
        });
        spinnerModalRef.componentInstance.mensaje = spinnerMessage;

        return spinnerModalRef;
      }
}
